import { render, staticRenderFns } from "./PaymentFileInfo.vue?vue&type=template&id=3eb6e9e6"
import script from "./PaymentFileInfo.vue?vue&type=script&lang=js"
export * from "./PaymentFileInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3eb6e9e6')) {
      api.createRecord('3eb6e9e6', component.options)
    } else {
      api.reload('3eb6e9e6', component.options)
    }
    module.hot.accept("./PaymentFileInfo.vue?vue&type=template&id=3eb6e9e6", function () {
      api.rerender('3eb6e9e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scholarship/jornalPayment/components/details/PaymentFileInfo.vue"
export default component.exports